/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import Spinner from '../../../common/Spinner/Spinner';
// import TruncatedContent from '../../../utils/TruncatedContent';
import formatDateToBR from '../../../utils/formatDateToBR';

const NewsAoVivoMostReadComponent = ({
    newsMostRead = [],
    fetchDataNewsMostReadIfNeeded = () => {},
    countNewsView = () => {},
}) => {
    useEffect(() => {
        fetchDataNewsMostReadIfNeeded();
    }, [fetchDataNewsMostReadIfNeeded]);

    const aoVivoNewsMostRead = newsMostRead;

    const BASE = 'https://a1media.antena1.com.br/image/news';

    const getImageProps = (imageNew) => {
        if (!imageNew) return { src: '/thumbnail_Default.jpg' };

        const encoded = encodeURI(imageNew);

        return {
            src: `${BASE}/482x250/${encoded}`,
            srcSet: `${BASE}/320x168/${encoded} 320w, ${BASE}/482x250/${encoded} 482w`,
            sizes: '(max-width: 767px) 320px, 482px',
        };
    };

    useEffect(() => {
        aoVivoNewsMostRead.forEach((news) => {
            countNewsView({
                newsId: news.newsId,
                timestamp: Date.now(),
            });
        });
    }, [aoVivoNewsMostRead, countNewsView]);

    const renderNews = () => aoVivoNewsMostRead.map((news) => {
        const link = `/noticias/${news.slug}`;
        const imgProps = getImageProps(news.imageNew);

        return (
            <Link
                key={news.newsId}
                to={link}
                className="tw-flex tw-flex-col tw-items-start tw-text-start"
                title={`Read more about ${news.title}`}
            >
                <p className="tw-text-sm tw-mb-0 tw-text-gray-500 data-publicacao">
                    {formatDateToBR(news.date)}
                </p>
                <div className="title-news">
                    <h3 className="limitText2 tw-text-lg tw-text-start tw-font-bold tw-text-black tw-mb-4">
                        {news.title}
                    </h3>
                </div>
                <div className="tw-w-full tw-mt-4 tw-overflow-hidden tw-h-56">
                    <img
                        className="tw-h-full tw-object-cover"
                        src={imgProps.src}
                        srcSet={imgProps.srcSet}
                        sizes={imgProps.sizes}
                        alt={news.title}
                    />
                </div>
            </Link>
        );
    });

    return (
        <section className="tw-w-full" id="section-mais-lidas-ouvir-radio">
            <div className="tw-container tw-m-auto tw-px-5">
                <header className="tw-mb-[25px] tw-flex tw-items-center tw-justify-between tw-border-t tw-border-b tw-border-black tw-py-[15px] tw-px-0">
                    <h2 className="tw-text-base tw-mb-0 tw-font-bold tw-text-gray-600">
                        Mais lidas da semana
                    </h2>
                </header>

                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-10">
                    {aoVivoNewsMostRead.length > 0 ? (
                        renderNews()
                    ) : (
                        <div className="tw-flex tw-justify-center tw-items-center">
                            <Spinner />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

NewsAoVivoMostReadComponent.prototype = exact({
    newsMostRead: PropTypes.array.isRequired,
    fetchDataNewsMostReadIfNeeded: PropTypes.func.isRequired,
    countNewsView: PropTypes.func.isRequired,
    breakpointReducer: PropTypes.object.isRequired,
})

export default NewsAoVivoMostReadComponent;
